var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebookDark = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 0H1.28571C0.944722 0 0.617695 0.135459 0.376577 0.376577C0.135459 0.617695 0 0.944722 0 1.28571L0 10.7143C0 11.0553 0.135459 11.3823 0.376577 11.6234C0.617695 11.8645 0.944722 12 1.28571 12H4.96205V7.92027H3.27455V6H4.96205V4.53643C4.96205 2.8717 5.95313 1.95214 7.47107 1.95214C8.19804 1.95214 8.95821 2.08179 8.95821 2.08179V3.71571H8.12063C7.29536 3.71571 7.03795 4.22786 7.03795 4.75313V6H8.88027L8.58562 7.92027H7.03795V12H10.7143C11.0553 12 11.3823 11.8645 11.6234 11.6234C11.8645 11.3823 12 11.0553 12 10.7143V1.28571C12 0.944722 11.8645 0.617695 11.6234 0.376577C11.3823 0.135459 11.0553 0 10.7143 0Z",
    fill: "#4E6297"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookDark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook-dark.b6e7d534.svg";
export { ForwardRef as ReactComponent };